<template>
    <div class="dialog draggable-item bg-light light center text-small w-100-sm w-100-md w-75-lg w-50-xl" v-cloak>

        <DialogTitle :title="serviceAccount.id == null ? $t('Add Service Account') : serviceAccount.name"
            :defaultTitle="serviceAccount.id == null ? $t('Add Service Account') : $t('Edit/Test Service Account')"
            :subTitle="serviceAccount.type_name" @closeDialog="$root.$emit('CLOSESERVICEACCOUNTDIALOG')" />


        <div class="dialog-content overflow bg-light">
            <div class="form-group d-flex flex-justify-between">
                <div class="d-flex flex-column">
                    <input type="radio" :data-caption="$t('Register an Azure application')" @click="registerApp = true" data-role="radio" name="r1" :checked="registerApp" class="mb-3">
                    <input type="radio" :data-caption="$t('Use an existing Azure application')" @click="registerApp = false" data-role="radio" name="r1" :checked="!registerApp">
                </div>
                <!--ISTRUZIONI PER RECUPERARE UN'APPLICAZIONE AZURE-->
                <div v-show="!registerApp" class="text-secondary w-60 border bg-white border-1 bd-black p-4">
                    <h5 class="fg-cobalt">{{ $t("Choose an Azure application") }}</h5>
                    <p>
                        <span>1 - {{ $t("Access ") }}</span>
                        <a :href="chooseAppURL" target="_blank" :title="chooseAppURL">{{ $t("this link") }}</a>
                        <span>{{ $t(" with your organisation's administrator account") }}</span>
                    </p>
                    <p>2 - {{ $t("Click on the name of the Azure application you want to use") }}</p>
                    <p>
                        <span>3 - {{ $t("From the left-hand menu, click on 'Authentication'. Under 'Mobile and desktop applications' and enter (if not already present) a redirect URI with the value:") }} </span>
                        <span>
                            <span>{{ redirectURI }}</span><span class="badge mif-copy" @click="$root.copy(redirectURI)"></span>
                        </span>
                    </p>
                    <p>4 - {{ $t("From the left-hand menu, return to the 'Overview' page and fill in the following fields with the information of chosen application") }}</p>               
                </div>
                <!--ISTRUZIONI PER REGISTRARE UN'APPLICAZIONE AZURE-->
                <div v-show="registerApp" class="text-secondary w-60 border bg-white border-1 bd-black p-4">
                    <h5 class="fg-cobalt">{{ $t("Register an Azure application") }}</h5>
                    <p>
                        <span>1 - {{ $t("Access ") }}</span>
                        <a :href="registerAppURL" target="_blank" :title="registerAppURL">{{ $t("this link") }}</a>
                        <span>{{ $t(" with your organisation's administrator account") }}</span>
                    </p>
                    <p>2 - {{ $t("Enter a name for your application (e.g. IperiusONE Azure App)") }}</p>
                    <p>3 - {{ $t("Choose the type of account supported (Caution: do not select 'Personal Microsoft accounts only')") }}</p>
                    <p>
                        <span>4 - {{ $t("Enter the redirect URI by selecting 'Public client/Native (mobile & desktop)' with the value") }}: </span>
                        <span>
                            <span>{{ redirectURI }}</span><span class="badge mif-copy" @click="$root.copy(redirectURI)"></span>
                        </span>
                    </p>
                    <p>5 - {{ $t("Click on the 'Register' button to confirm your application") }}</p>
                    <p>6 - {{ $t("Fill in the following fields with the information of your newly registered application") }}</p>
                </div>
            </div>
            
            <div v-if="serviceAccount.type == $ONEServiceType.Cloud_OneDrive" class="form-group">
                <label>{{ $t("User email") }}*</label>
                <input data-role="input" v-model.trim="serviceAccount.username" type="text" required v-no-autocomplete/>
                
            </div>
            <!--<div class="form-group">
                <label>{{ $t("Application name") }}</label>
                <input data-role="input" v-model.trim="serviceAccount.options.appName" type="text" required />
                <small class="text-muted">{{ $t("Required") }}</small>
            </div>-->
            <div class="form-group">
                <label>{{ $t("Application (client) ID") }}*</label>
                <input data-role="input" v-model.trim="serviceAccount.client_id" type="text" required />
                
            </div>
            <!--<div class="form-group">
                <label>{{ $t("Object ID") }}</label>
                <input data-role="input" v-model.trim="serviceAccount.options.objID" type="text" required />
                <small class="text-muted">{{ $t("Required") }}</small>
            </div>-->
            <div class="form-group">
                <label>{{ $t("Directory (tenant) ID") }}*</label>
                <input data-role="input" v-model.trim="serviceAccount.options.tenant_id" type="text" required />
                
            </div>
                
            <div class="form-group" :disabled="serviceAccount.id == null && testState != OK">
                <label>{{ $t("Name") }}*</label>
                <input :disabled="serviceAccount.id == null && testState != OK" data-role="input" type="text" v-model.trim="serviceAccount.name" maxlength="50"
                    :placeholder="$t('enter name')" data-prepend="<span class='mif-pencil'></span>" />
                
            </div>

            <!--------------MICROSOFT - MODERN AUTH ---------------------------->
            <!--15/01/24 : Tolta la basic per exchange 365-->
            <!--<div v-show="!serviceAccount.type.isExchangeOnPremises()">-->
                
                
                <!--<div class="form-group">
                    <label>{{ $t("Region") }}</label>
                    <select class="select w-auto" v-model="serviceAccount.region">
                        <option v-for="region in regions" :value="region.Url" :key="region.Url">{{
                            region.Name
                        }}</option>
                    </select>
                    <small class="text-muted">{{ $t("Required") }}</small>
                </div>-->
                <!--Visualizzato solo in edit, perchè si imposano automaticamente i permessi alla creazione-->
            <!--</div>-->

            <!------EXCHANGE ON PREMISES = username, password, server, domain, include child domains------------->
            <!--NON INCLUSO NELLA VERSIONE BETA DI IPERIUSONE-->
            <!--<div v-show="serviceAccount.type.isExchangeOnPremises()" class="form-group">
                <label>{{ $t("Server") }}</label>
                <input data-role="input" type="text" class="metro-input" v-model.trim="serviceAccount.options.server"
                    :placeholder="$t('Enter Server')" data-prepend="<span class='mif-cloud'></span>" />
                <small class="text-muted">{{ $t("Required") }}</small>
            </div>-->

            <div v-show="serviceAccount.type.isExchangeOnPremises()" class="form-group">
                <div class="row">
                    <div class="cell-8">
                        <label>{{ $t("Domain") }}</label>
                        <input data-role="input" class="metro-input" type="text" v-model.trim="serviceAccount.options.domain"
                            :placeholder="$t('Enter Domain')" data-prepend="<span class='mif-cloud'></span>" />
                        
                    </div>
                    <div class="cell-4 pt-6">
                        <input data-role="checkbox" type="checkbox" :data-caption="$t('Include child domains')"
                            data-validate="required" v-model="serviceAccount.options.IncludeChildDomains" required
                            data-prepend="<span class='mif-server'></span>" />
                    </div>
                </div>
            </div>

            <div v-show="serviceAccount.type.isExchangeOnPremises()" class="form-group">
                <label>{{ $t("Username") }}</label>
                <input data-role="input" class="metro-input" v-model.trim="serviceAccount.username" type="text" required
                    data-prepend="<span class='mif-person'></span>" />
                
            </div>

            <div v-show="serviceAccount.type.isExchangeOnPremises()" class="form-group">
                <label>{{ $t("Password") }}</label>
                <input v-if="[null, ''].includes(serviceAccount.id)" class="metro-input" data-role="input" type="password" v-model.trim="serviceAccount.password" :placeholder="$t('Enter Password')" v-no-autocomplete="'mif-lock'" />
                <input v-else class="metro-input" data-role="input" type="password" data-reveal-button="false" data-prepend="<span class='mif-lock'></span>" value="**********" disabled/>
            </div>


            <!-------------------------------SCELTA PC----------------------------------------->
            <div v-if="serviceAccount.type.isExchangeOnPremises() && $session.getRoomPC() == null"
                class="form-group">
                <label>
                    <span>{{ $t("Select PC to Test Service Account") }}</span>
                </label>
                <select class="select cell-9" v-model="testPC" :disabled="$session.getPCList().length == 0">
                    <option :data-append="pc.description" v-for="pc in $session.getPCList()" :value="pc"
                        :disabled="!$root.connectionsStates[pc.id]" v-bind:key="pc.id"> {{ pc.pc_name }}
                    </option>
                </select>
            </div>


        </div>

        <!-------------------------------TEST ACCOUNT----------------------------------------->
        <div class="dialog-actions d-flex " :class="step == null ? 'flex-justify-end' : 'flex-justify-end'">

            <ClientMessageView :commands="['testserviceaccount']"/>
            <button v-show="testState == OK" class="button bg-amber" disabled> {{ $t("Test account") }}</button>                
            <div class="button secondary" v-show="testState == WAIT"><span class="mif-spinner2 ani-spin ml-2 mr-2" /></div>
            <button v-show="testState == NOTOK" class="button bg-amber" @click="test" :disabled="!enableTest" v-disable-tooltip="$t('Edit connection credentials before testing the account.')"> {{ $t("Test account") }} </button>
            
            <button class="button secondary" :disabled="!enableSave" v-disable-tooltip="$t('You can save the account only if the account test is successful.')" @click="saveServiceAccount(serviceAccount)"> {{ $t("Save") }} </button>            
        </div>
    </div>
</template>

<script>
import DialogTitle from "../../utils/DialogTitle.vue";
import { isValid } from "../../../utils/utilitiesmodule";
import { draggableMixin } from '../../../mixins/draggable-mixin'
import ClientMessageView from "../view/ClientMessageView.vue"
import { saveServiceAccount, testServiceAccount } from "../../../utils/entityMethods/serviceAccount";



export default {

    mixins: [draggableMixin],
    name: "MicrosoftServiceAccount",
    components: {
        "DialogTitle": DialogTitle,
        ClientMessageView
    },
    props: {
        serviceAccount: Object,
    },
    data() {
        return {
            registerApp: true,
            chooseAppURL: "https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationsListBlade",
            registerAppURL: "https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/CreateApplicationBlade/quickStartType~/null/isMSAApp~/false",
            redirectURI: window.location.origin,//"http://localhost:8080",
            testPC: null,
            testResult: null,
            // -1 : avviato
            // 0 : non avviato o fallito
            // 1 : ok
            testState: 0,
            NOTOK: 0,
            WAIT: -1,
            OK: 1,
            regions: [],

            step: null,

            forbiddenChars: "!@#$%^&*()=+{}[]\\|;:\"'<>,.?/",
            forbiddenNames: [
                "Microsoft", "Azure", "Office", "Windows", "Dynamics", "Outlook", "Teams",
                "OneDrive", "SharePoint", "PowerBI", "VisualStudio", "MSFT", "MS",
                "WindowsServer", "Intune", "Exchange", "Google", "Gmail", "Android",
                "YouTube", "GoogleCloud", "Amazon", "AWS", "Alexa", "Prime",
                "AmazonWebServices", "Apple", "iCloud", "iPhone", "iPad", "iOS",
                "Facebook", "Instagram", "WhatsApp", "Oculus", "IBM", "Watson",
                "Oracle", "Java", "Salesforce", "Heroku", "LinkedIn", "Twitter",
                "Netflix", "Spotify", "Slack", "Zoom", "Adobe", "Dropbox", "GitHub",
                "Pinterest", "Snapchat", "TikTok", "Hulu", "PayPal", "Stripe",
                "Admin", "Support", "Service", "Helpdesk", "Root", "System",
                "Default", "User", "Guest"
            ]
        }
    },
    computed: {
        name() {
            if (!isValid(this.serviceAccount.username)||!isValid(this.serviceAccount.options.appName)) {
                return "";
            }
            this.serviceAccount.name=this.serviceAccount.username.split("@")[0]+" - "+this.serviceAccount.options.appName;
            return this.serviceAccount.name;
        },
        allInputCompleted() {
            var specificInputsCompleted;
            switch (this.serviceAccount.type) {
                case this.$ONEServiceType.Microsoft_Exchange365:
                case this.$ONEServiceType.Microsoft_SharePoint:
                case this.$ONEServiceType.Microsoft_Teams:
                case this.$ONEServiceType.Microsoft_OneDriveForBusiness:
                case this.$ONEServiceType.Cloud_OneDrive:
                    specificInputsCompleted=
                        (this.serviceAccount.type!=this.$ONEServiceType.Cloud_OneDrive||this.serviceAccount.username!="")&&
                        //this.serviceAccount.options.appName!=""&&
                        this.serviceAccount.client_id!=""&&
                        //this.serviceAccount.options.objID!=""&&
                        this.serviceAccount.options.tenant_id!="";
                    //this.serviceAccount.region!=""&&
                    break;
                case this.$ONEServiceType.Microsoft_ExchangeOnPremises:
                case this.$ONEServiceType.Microsoft_ExchangeOnPremisesEWS:
                    specificInputsCompleted=this.serviceAccount.server!=""&&
                        this.serviceAccount.domain!=""&&
                        this.serviceAccount.username!=""&&
                        this.serviceAccount.password!="";
                    break;
            }
            return (!this.serviceAccount.type.isExchangeOnPremises()||this.$session.getRoomPC()!=null||this.testPC!=null)
                &&specificInputsCompleted;//this.serviceAccount.name!=""&&
            //il pc è richiesto solo nel caso di exchange on premises

        },
        enableTest() {
            if (this.testState==this.OK)
                return false;

            return this.allInputCompleted&&this.testState==this.NOTOK;
        },
        enableSave() {

            if (!this.allInputCompleted) {
                return false;
            }

            if (this.serviceAccount.name=="") {
                return false;
            }
            //Durante il primo test, si assegnano i permessi
            if (this.serviceAccount.id==null&&this.testState==this.OK) {
                return true;
            }

            if (this.serviceAccount.id!=null) {
                return true;
            }

            return false;
        }

    },
    created() {
        if (this.serviceAccount.id!=null) {
            this.registerApp=false;
            return;
        }
        this.registerApp=true;
        this.testPC=this.$session.getPCWithID(this.serviceAccount.options.lastTestPC);
        this.serviceAccount.url=window.location.origin;
    },


    methods: {
        saveServiceAccount,
        testServiceAccount,

        async test() {
            let self=this;
            self.testState=this.WAIT; // test in corso

            //Exchange On-Premises
            if (self.serviceAccount.type.isExchangeOnPremises()) {
                self.testState=(await this.testServiceAccount(self.serviceAccount, self.testPC)).okNumber;
                return;
            }

            //Exchange 365 + ModernAuth

            var checkedName=this.validateAndReplace(self.serviceAccount.name);

            //Se il service account è di tipo Exchange 265, avvio un timer che legge il cookie che conterrà un messaggio che descrive il corrente step


            if (this.testResult==null||!this.testResult.ok) {
                this.testResult=await this.testServiceAccount(self.serviceAccount);
            }

            self.testState=this.testResult.okNumber;
            if (this.testResult.ok) {
                self.serviceAccount.client_id=this.testResult.serviceAccount.client_id;
                self.serviceAccount.client_secret=this.testResult.serviceAccount.client_secret;
                self.serviceAccount.options["objID"]=this.testResult.serviceAccount.options.objID;
                self.serviceAccount.options["appName"]=this.testResult.serviceAccount.options.appName;
                self.serviceAccount.token=this.testResult.serviceAccount.token;
                self.serviceAccount.refresh_token=this.testResult.serviceAccount.refresh_token;
                self.serviceAccount.name=this.testResult.serviceAccount.options.appName;
            }

            clearInterval(self.readStepCookie);
            self.readStepCookie=null;
        },

        validateAndReplace(inputString) {
            // Controllo se la stringa contiene un nome proibito
            const lowerCaseInput=inputString.toLowerCase();
            for (let name of this.forbiddenNames) {
                if (lowerCaseInput.includes(name.toLowerCase())) {
                    return false;
                }
            }

            // Sostituzione dei caratteri proibiti con lo spazio
            /*let processedString = inputString;
            for (let char of forbiddenChars) {
                processedString = processedString.split(char).join(' ');
            }*/
            for (let char of this.forbiddenChars) {
                inputString=inputString.split(char).join(' ');
            }
            inputString=inputString.trimStart().trimEnd();
            while (inputString.indexOf("  ")!=-1) {
                inputString=inputString.replace("  ", " ");
            }

            return inputString;
        }
    }
}

</script>
